(() => {
  const applyWishlistIcons = () => {
    const icon = document.querySelector('.aasaved-cart-trigger svg');
    if (!icon) return;
    document.querySelectorAll('.save-product:not([data-icon-loaded])').forEach(btn => {
      btn.innerHTML = icon.outerHTML;
      btn.dataset.iconLoaded = "true";
    });
    document.querySelectorAll('.aasaved-cart-actions:not([data-icon-loaded])').forEach(btn => {
      btn.querySelector('a')?.insertAdjacentHTML('afterbegin', icon.outerHTML);
      btn.dataset.iconLoaded = "true";
    });

    document.querySelectorAll('.aasaved-cart-dropdown-overlay a').forEach(anchor => {
      anchor.setAttribute("target", "_self")
    });
  };

  document.addEventListener("click", e => {
    const btn = e.target.closest(".save-product");
    if (!btn || btn.classList.contains("wishlist-processing")) return;

    btn.classList.add("wishlist-processing");

    window.cartSaver.productCallback = () => [{
      variant_id: btn.dataset.variantId,
      quantity: 1,
      properties: null,
    }];

    window.cartSaver.openSelector();
    setTimeout(() => btn.classList.remove("wishlist-processing"), 500);
  });

  const observer = new MutationObserver(applyWishlistIcons);
  observer.observe(document.body, { childList: true, subtree: true });

  const interval = setInterval(() => {
    applyWishlistIcons();
    if (document.querySelector('.save-product[data-icon-loaded="true"]')) clearInterval(interval);
    if (document.querySelector('.aasaved-cart-actions:not([data-icon-loaded="true"])')) clearInterval(interval);
  }, 200);
})();
